export default {
  SEND_INSTRUCTION: 1,
  COMPLIMENT_CARD: 2
}
